import * as React from 'react';
import { useSelector } from 'react-redux';
import { MoreDetailed } from '../../../components/OffersHistory/shared/MoreDetailed';
import { selectIsWebview } from '../../../selectors/page';

export const MoreDetailedContainer: React.FC = () => {
  const isWebview = useSelector(selectIsWebview);

  return <MoreDetailed isWebview={isWebview} />;
};

MoreDetailedContainer.displayName = 'MoreDetailedContainer';
